import { QuestionMarkIcon } from '@fourthwall/icons';
import React, { useState } from 'react';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import * as S from './styled';
const getSize = (size) => {
    switch (size) {
        case 'xsmall':
            return 12;
        case 'small':
            return 15;
        case 'medium':
        default:
            return 18;
    }
};
export const InfoTooltip = ({ appearance = 'primary', size = 'small', content, placement, fluid = false, }) => {
    const [isTooltipHover, setIsTooltipHover] = useState(false);
    if (!content) {
        return null;
    }
    return (React.createElement(S.TooltipContainer, { "$isOpen": isTooltipHover, "$appearance": appearance, onMouseEnter: () => setIsTooltipHover(true), onMouseLeave: () => setIsTooltipHover(false) },
        React.createElement(Tooltip, { reference: React.createElement(Icon, { component: QuestionMarkIcon, height: getSize(size) }), fluid: fluid, strategy: "fixed", placement: placement }, content)));
};
//# sourceMappingURL=InfoTooltip.js.map